// extracted by mini-css-extract-plugin
export default {"home-room-section-icon":"styles_home-room-section-icon__DaFHl","home-room-section-icon__content":"styles_home-room-section-icon__content__WeGCk"};